import { UserFormSettings } from 'features/admin-users/types/user-form-settings.type';
import { FormAction } from 'shared/ts-types/form-action.type';

export const ROLE_FORM_SETTINGS: Record<FormAction, UserFormSettings> = {
  CREATE: {
    CONFIRM_BTN_TEXT: 'Create',
    CONFIRM_MODAL_TITLE: 'Are you sure you want to create a new role?',
  },
  UPDATE: {
    CONFIRM_BTN_TEXT: 'Update',
    CONFIRM_MODAL_TITLE: 'Are you sure you want to update this role?',
  },
};
